import InscriereSuccessPage from './inscriere-success-page';

export default InscriereSuccessPage;
